// Auto-generated build version — updated by post-build.cjs
export const BUILD_VERSION = "26.09.2026, 13:47:25";
export const BUILD_TIMESTAMP = "2026-09-26T10:47:25.550Z";
